/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
import { lazy } from "react";

export default {
	'test-message-inapp': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--test-message-inapp/placements/in-app/screen-space-flags/render'
			),
	),
	'test-message-inapp-ep-modal': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--test-message-inapp-ep-modal/placements/in-app/screen-space-flags/render'
			),
	),
	'test-message-inapp-implicit-pendo': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--test-message-inapp-implicit-pendo/placements/in-app/screen-space-flags/render'
			),
	),
	'test-message-tap-ingestion-trigger-subscription': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--test-message-tap-ingestion-trigger-subscription/placements/in-app/screen-space-flags/render'
			),
	),
};
